import ApolloClient from 'apollo-boost'
import fetch from 'unfetch'

export const API_ENDPOINT = window.location.origin.replace('book.', '').replace('www.', '').replace('https://', 'https://api.')

export const client = new ApolloClient({
  uri: API_ENDPOINT,
  fetch,
})
